import { FC, PropsWithChildren, Ref } from 'react';
import styled from 'styled-components';
import { colorPrimary } from '@atlas-frontend/design-tokens';

export interface WithRowDragTargetCrosshairProps extends PropsWithChildren {
  containerRef: Ref<HTMLDivElement>;
}

export const WithRowDragTargetCrosshair: FC<WithRowDragTargetCrosshairProps> = (
  props,
) => (
  <Wrapper
    className="row-drag-target-crosshair-container"
    ref={props.containerRef}
  >
    <div className="row-drag-target-crosshair" />
    {props.children}
  </Wrapper>
);

const Wrapper = styled.div`
  position: relative;

  .row-drag-target-crosshair {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    margin-top: -1px;
    background-color: ${colorPrimary};
    pointer-events: none;
    opacity: 0;
    transition-duration: 0.1s;

    &.is-visible {
      opacity: 1;
      transition-property: opacity;
      transition-delay: 0.3s;
    }

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      width: 8px;
      height: 8px;
      border-radius: 100%;
      border: 2px solid ${colorPrimary};
      background-color: white;
      left: 0;
      transform: translate(0, -50%);

      baseline-shift: 20px;
    }
  }
`;
